import { gossipEvents } from "@/mocks/events";
import SectionHeading from "@/components/feature/SectionHeading";
import EventCard from "@/components/feature/EventCard";
import Reveal from "@/components/base/Reveal";

export default function LatestDigest() {
  const latest = [...gossipEvents].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 3);
  const rest = [...gossipEvents]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(3, 6);

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="LATEST DIGEST"
          title="最新盘点 · 这周刚整理完的瓜"
          desc="按最近整理时间排列。凡是出现新节点，都会在原事件串上追加，不会另开一条，所以直接看这里就能追上进度。"
          linkTo="/events"
          linkLabel="全部事件"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {latest.map((event, index) => (
            <Reveal key={event.id} delay={index * 80} className="h-full">
              <EventCard event={event} />
            </Reveal>
          ))}
        </div>

        <div className="mt-5 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {rest.map((event, index) => (
            <Reveal key={event.id} delay={index * 80} className="h-full">
              <EventCard event={event} variant="wide" />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}